import axios from 'axios';

const API_BASE_URL = 'https://mbvipsoft.com/mbvipsoft_api/zono';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('session_id');

  if (token) {
    config.headers.Authorization = `Session ${token}`;
  }

  return config;
});

export function requestVerificationCode(phoneNumber) {
  return apiClient
    .post('/auth/request-code/', {
      phone_number: phoneNumber,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(
          error.response.data.message || 'Failed to request verification code'
        );
      }

      throw new Error('Network error');
    });
}

export function verifyPhoneCode(phoneNumber, code) {
  return apiClient
    .post('/auth/verify-code/', {
      phone_number: phoneNumber,
      code: code,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Verification failed');
      }

      throw new Error('Network error');
    });
}

export function logoutRequest() {
  return apiClient
    .post('/auth/logout/')
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // גם אם יש שגיאה - נרצה עדיין לנקות session מקומית
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Logout failed');
      }

      throw new Error('Network error');
    });
}

export default apiClient;